/**
 * Created by sswaminathan on 1/6/23
 * File: BackboneListing
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Checkbox } from '@panwds/react-form-legacy'
import { Button, Bold, Tooltip } from '@panwds/react-ui'
import { PlusCircleIcon } from '@panwds/icons'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { APP_ID_PRISMA_ACCESS_EDITION } from '../../../../../common/constants/GlobalConstants'
import {
  BACKBONE_LABEL_HEADER,
  BACKBONE_SECTION_HEADER,
  BACKBONE_TOOLTIP_CONTENT
} from '../../../constants/SubscriptionConstant'
import BackBoneRegionModal from './BackBoneRegionModal'
/**
 *   TODO: Brief what is this component/class do
 */
import SectionHeaders from './SectionHeaders'

const BackboneListing = (props) => {
  const [checkBoxState, setCheckBoxState] = useState(false)
  const { setValue } = useFormContext()
  const { isSingleTenant = false, licenseAction, selectedTreeNode, instancesKeyBy } = props
  const [disabled, setDisabled] = useState(false)
  useEffect(() => {
    if (licenseAction === 'EDIT') {
      const instances = instancesKeyBy ? instancesKeyBy[selectedTreeNode?.id] : []
      const isBackBoneActivated = instances?.some(each => {
        return each?.extra?.backbone_selection
      })
      const isPAEActivated = instances?.some(each => {
        return each.app_id === APP_ID_PRISMA_ACCESS_EDITION
      })
      setDisabled(isPAEActivated)
      if (isBackBoneActivated) {
        setDisabled(isBackBoneActivated)
        setValue('isSpInterconnectRequired', isBackBoneActivated)
        setCheckBoxState(isBackBoneActivated)
      }
    }
  }, [instancesKeyBy, licenseAction, selectedTreeNode?.id, setDisabled, setValue])
  return (<div>
    <div className='tw-flex tw-items-center tw-pt-2'>
      <SectionHeaders {...{ header: BACKBONE_SECTION_HEADER }} />
      <Tooltip label={BACKBONE_TOOLTIP_CONTENT}>
        <Button
          aria-label='contract-button'
          icon={<PlusCircleIcon size='sm' />}
          appearance='clear'
          style={{ background: 'transparent' }}
        />
      </Tooltip>
    </div>
    <div className={`tw-flex tw-flex-col ${isSingleTenant ? '' : ''}`} style={{ flexBasis: '38%' }}>
      <div className="tw-flex tw-items-center tw-flex-1 tw-gap-2">
        <Checkbox
          addClassName={`${!isSingleTenant ? 'tw-ml-2' : ''}`}
          name="isSpInterconnectRequired"
          showLabel={false}
          label="SP Backbone Required"
          defaultValue={checkBoxState}
          disabled={disabled}
          register={{
            //value: checkBoxState,
            required: false,
            onChange: () => {
              setCheckBoxState(!checkBoxState)
            }
          }}
        />
        <Bold addClassName={`${isSingleTenant ? '' : 'tw-pl-2'} tw-text-xs tw-pt-2`}>{BACKBONE_LABEL_HEADER}</Bold>

      </div>
    </div>
    <div className='tw-mt-4'>
      {checkBoxState && <BackBoneRegionModal {...{ ...props }}/>}
    </div>
  </div>)
}

BackboneListing.propTypes = {}
export default BackboneListing
